import lgCloiBipartiteRobot from '../../../../assets/images/learn/lg-cloi-bipartite-robot.png';
import robotisGaemi from '../../../../assets/images/learn/robotis-gaemi.png';
import hyundaiRoboticsW3 from '../../../../assets/images/learn/hyundai-robotics-w3.png';
import { cEl } from '../../../../util';

function MiniRobot() {
    const page = cEl('div');
    page.classList.add('learn-page');
    page.innerHTML = `
    <div class="gray-box">
        <h2>소형 배송 로봇</h2>
        <div class="img-container">
            <div class="img-wrapper border-radius">
                <img src="${lgCloiBipartiteRobot}" alt="LG전자 CLOi 양문형 배송로봇">
                <span>LG전자 CLOi 양문형 배송로봇</span>
            </div>
            <div class="img-wrapper border-radius">
                <img src="${robotisGaemi}" alt="로보티즈 집개미">
                <span>로보티즈 집개미</span>
            </div>
            <div class="img-wrapper border-radius">
                <img src="${hyundaiRoboticsW3}" alt="현대로보틱스 W3">
                <span>현대로보틱스 W3</span>
            </div>
        </div>
        <div class="description-container">
            <div class="description-wrapper" style="flex: 0 0 250px">
                <div class="description-topic">사용처</div>
                <ul class="description-list">
                    <li>부서 간 물품 배송</li>
                </ul>
            </div>
            <div class="description-wrapper" style="flex: 0 0 250px">
                <div class="description-topic">선반 종류</div>
                <ul class="description-list">
                    <li>잠금형 수납 선반</li>
                </ul>
            </div>
            <div class="description-wrapper" style="flex: 0 0 250px">
                <div class="description-topic">장점</div>
                <ul class="description-list">
                    <li>다양한 방식의 보안 장치</li>
                    <li>통제문 및 엘리베이터 연동 가능</li>
                </ul>
            </div>
            <div class="description-wrapper" style="flex: 0 0 250px">
                <div class="description-topic">주의점</div>
                <ul class="description-list">
                    <li>수평 이동 제약(경사로, 여닫이문 등)</li>
                    <li>물건을 직접 수납, 수거해야 함</li>
                </ul>
            </div>
        </div>
    </div>`;

    return page;
}

export default MiniRobot;
